import React from 'react';
import { asyncComponent } from 'react-async-component';

const Studio94Layout = asyncComponent<{}>({
  resolve: () => new Promise((res, rej) => {
    require.ensure([], (require) => {
      const item = require('./Layout').default;
      res(item as React.ComponentClass<{}>);
    }, 'studio94-layout');
  })
});

export default Studio94Layout;
